import { Link } from "react-router-dom";
import React, { useContext, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";
import axios from "axios";

export default function Company() {
  const { state } = useContext(GlobalContext);
  const { data, setData, setFetchStatus } = state;

  // Seacrh
  const [seacrh, setSeacrh] = useState("");
  const handleChangeSeacrh = (event) => setSeacrh(event.target.value);
  const handleSeacrh = (event) => {
    event.preventDefault();
    // console.log(seacrh)
    let fetchData = async () => {
      setData(null);
      let result = await axios.get(
        `https://dev-example.sanbercloud.com/api/job-vacancy`
      );
      let data = result.data.data;

      setData(data);
      let searchData = data.filter((res) => {
        return Object.values(res)
          .join(" ")
          .toLowerCase()
          .includes(seacrh.toLowerCase());
      });

      setData([...searchData]);
    };
    fetchData();
    setSeacrh("");
  };

  return (
    <>
      <section className="bg-white dark:bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
          <div className="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
            <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
              Open Vacancy Job
            </h2>
            <p className="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">
              Explore the job that suits to you
            </p>
            <div className="flex">
              <form onSubmit={handleSeacrh} className="w-full">
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-gray-300"
                >
                  Search
                </label>
                <div className="relative">
                  <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5 text-gray-500 dark:text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="search"
                    value={seacrh}
                    onChange={handleChangeSeacrh}
                    id="default-search"
                    className="block p-4 pl-10 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Search Job here..."
                    required
                  />
                  <button
                    type="submit"
                    className="text-white absolute right-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Search
                  </button>
                </div>
              </form>
              <button
                className="bg-red-600 rounded-lg text-white w-36 ml-5"
                onClick={() => setFetchStatus(true)}
              >
                Reset Data
              </button>
            </div>
          </div>

          <div className="grid gap-8 mb-6 lg:mb-16 md:grid-cols-3">
            {data !== null &&
              data.map((res, index) => {
                return (
                  <Link
                    key={index}
                    to={`${res.id}`}
                    className="items-center bg-gray-50 rounded-lg border-2 border-slate-200 shadow sm:flex dark:bg-gray-800 dark:border-gray-700"
                  >
                    <div>
                      <img
                        className="w-40 h-36 rounded-lg sm:rounded-none sm:rounded-l-lg"
                        src={res.company_image_url}
                        alt="Company Imager"
                      />
                    </div>
                    <div className="px-5">
                      <h3 className="text-base font-bold tracking-tight text-gray-900 dark:text-white">
                        {res.title} ({res.job_tenure})
                      </h3>
                      <span className="text-gray-500 dark:text-gray-400">
                        {res.company_name}
                      </span>
                      <p className="font-light text-gray-500 dark:text-gray-400">
                        {res.company_city}, {res.job_type}
                      </p>
                      <p className="font-light text-gray-500 dark:text-gray-400">
                        {res.created_at}
                      </p>
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      </section>
    </>
  );
}
